import PropTypes from 'prop-types';

import {OEFNHelpPropTypes} from '../help/oe-flow-nav-help-model';
import {OEFNStartSelectionPropTypes} from '../start-selection/oe-fn-start-selection-model';

export const OEFNWelcomeEntryTypes = {
    text:                       'text',
    menu:                       'menu',
    button:                     'button',
    home:                       'home',
    licensing:                  'licensing',
    mediaCenter :               'mediaCenter',
    help :                      'help',
    infoHelp:                   'infoHelp',
    quickStart:                 'quickStart',
    manual:                     'manual',
    startSelection:             'startSelection',
    currentStartSelectionTitle: 'currentStartSelectionTitle',
    spacer:                     'spacer',
    dontShowCheckbox:           'dontShowCheckbox',
    maskBlock:                  'maskBlock',
    urlLink:                    'urlLink'
};

//
export const OEFNWelcomePropDecl = {
    locStringPrefix:            PropTypes.string,
    entries: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.oneOf([
            OEFNWelcomeEntryTypes.text,
            OEFNWelcomeEntryTypes.menu,
            OEFNWelcomeEntryTypes.button,
            OEFNWelcomeEntryTypes.home,
            OEFNWelcomeEntryTypes.licensing,
            OEFNWelcomeEntryTypes.mediaCenter,
            OEFNWelcomeEntryTypes.help,
            OEFNWelcomeEntryTypes.infoHelp,
            OEFNWelcomeEntryTypes.quickStart,
            OEFNWelcomeEntryTypes.manual,
            OEFNWelcomeEntryTypes.startSelection,
            OEFNWelcomeEntryTypes.currentStartSelectionTitle,
            OEFNWelcomeEntryTypes.spacer,
            OEFNWelcomeEntryTypes.dontShowCheckbox,
            OEFNWelcomeEntryTypes.maskBlock,
            OEFNWelcomeEntryTypes.urlLink
        ]).isRequired,
        className:              PropTypes.string,
        id:                     PropTypes.string,
        stringId:               PropTypes.string,
        string:                 PropTypes.string,
        html:                   PropTypes.bool,
        icon:                   PropTypes.string,
        enabled:                PropTypes.bool,
        link:                   PropTypes.any,
        linkId:                 PropTypes.string,
        onClick:                PropTypes.func,
        logo:                   PropTypes.string,
        height:                 PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        minHeight:              PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        spacerHeight:           PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        noSubtitle:             PropTypes.bool,
        fontSize:               PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        mask: PropTypes.shape({
            licenseValid:       PropTypes.bool,
            licensingAccess:    PropTypes.func
        }),
        viewTitle:              PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        flowNavModalFlags:      PropTypes.number,
        targetType:             PropTypes.string,
        startSelection:         PropTypes.oneOfType([OEFNStartSelectionPropTypes.content, OEFNStartSelectionPropTypes.startSelection])
    })),
    autoSpacerHeight:           PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    help: PropTypes.shape(Object.assign({
        showLogo:               PropTypes.bool
    }, OEFNHelpPropTypes.propTypes)),
    infoHelp:                   PropTypes.shape(OEFNHelpPropTypes.propTypes)
};

//
export class OEFNWelcomeEntryFactory {

    constructor(entries, ref = true) {
        this.set(entries, ref);
    }

    set(entries, ref = false)    {      // ref == true -> overwrite reference
        if(!Array.isArray(entries))    {
            if(!ref && this.entries) {
                if(this.entries.length) this.entries.splice(0, this.entries.length);
            } else {
                this.entries = [];
            }
            return this;
        }

        if(ref) {
            this.entries = entries;
        } else {
            if(!Array.isArray(this.entries))    this.entries = [];
            this.entries.splice(0, this.entries.length, ...entries);
        }

        return this;
    }

    build(copy = true)   {
        if(!copy)    return this.entries;
        return clone(this.entries);
    }

    clear() {
        return this.set(undefined, false);
    }

    def()   {
        return this.set(OEFNWelcomeEntryFactory.buildDef(), false);
    }

    addEntry(entry)   {
        this.entries.push(entry);
        return this;
    }

    insertEntryAtIndex(index, entry)   {
        this.entries.splice(index, 0, ...entry);
        return this;
    }

    removeEntryAtIndex(index)    {
        this.entries.splice(index, 1);
        return this;
    }

    replaceEntryAtIndex(index, entry)    {
        this.entries.splice(index, 1, ...entry);
        return this;
    }
};

OEFNWelcomeEntryFactory.buildDef = function()  {
    return [
        {type: OEFNWelcomeEntryTypes.spacer, height: '3.25em' /*52px*/},
        {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', mask: {licenseValid: true}},
        {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', mask: {licenseValid: false}},
        {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32px*/},
        {type: OEFNWelcomeEntryTypes.licensing, mask: {licenseValid: false}},
        {type: OEFNWelcomeEntryTypes.home, stringId: 'welcome_view_home_v2'},
        {type: OEFNWelcomeEntryTypes.mediaCenter, stringId: 'welcome_view_pres_v2'},
        {type: OEFNWelcomeEntryTypes.quickStart},
        {type: OEFNWelcomeEntryTypes.manual},
        {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20px*/},
        {type: OEFNWelcomeEntryTypes.dontShowCheckbox, noSubtitle: true, stringId: 'welcome_view_dont_show_again_title_v2'},
        {type: OEFNWelcomeEntryTypes.spacer, height: '0.5em' /*8px*/}
    ];
};